import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NewsPromotionItem, NewsPromotionService } from '../../services/news-promotion.service';

@Component({
  selector: 'app-news-promotion-detail',
  templateUrl: './news-promotion-detail.component.html',
  styleUrls: ['./news-promotion-detail.component.css']
})
export class NewsPromotionDetailComponent implements OnInit {
  article: NewsPromotionItem | null = null;
  isLoading = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private newsPromotionService: NewsPromotionService
  ) { }

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    const id = Number(idParam);

    if (!id || Number.isNaN(id)) {
      this.router.navigate(['/news-promotions']);
      return;
    }

    this.loadArticle(id);
  }

  get contentParagraphs(): string[] {
    if (!this.article?.content) {
      return [];
    }

    return this.article.content
      .split(/\n\s*\n|\r\n\s*\r\n/)
      .map((p) => p.trim())
      .filter((p) => p.length > 0);
  }

  private loadArticle(id: number): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.newsPromotionService.getById(id).subscribe({
      next: (item) => {
        if (!item) {
          this.router.navigate(['/news-promotions']);
          return;
        }

        this.article = item;
        this.isLoading = false;
      },
      error: () => {
        this.errorMessage = 'Unable to load this story right now. Please try again later.';
        this.isLoading = false;
      }
    });
  }
}
